module.exports = "/virtual-football-league/img/amblems/right/logos/Schalke.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/right/logos/Schalke.png
// module id = 2228
// module chunks = 4